import { useFetchApi } from "src/ssc-api/useFetchApi";
import { CruiseQueryPageProps } from "src/templates/Cruise";
import { SpecialVoyageQueryPageProps } from "src/templates/NewSpecialVoyage";

export function useStaticCruise<
  T extends CruiseQueryPageProps | SpecialVoyageQueryPageProps
>(cruisePage: string | undefined) {
  const urlWithourParams = cruisePage?.split("?")[0];
  const offerPageUrl = cruisePage
    ? `/page-data${urlWithourParams}/page-data.json`
    : undefined;
  const { status, data } = useFetchApi<{
    result: {
      data: T;
    };
  }>(offerPageUrl);

  return {
    status,
    staticData: data?.result?.data
  };
}
